import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';


import { IState } from '../../shared/store/root.reducer';
import { AuthService } from '../../shared/services/auth.service';
import { AppParamsActions } from '../../shared/store/app-params.reducer';
import { BreadcrumbService } from 'src/app/shared/services/breadcrumb.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-external-login',
  templateUrl: './external-login.component.html',
  styleUrls: ['./external-login.component.scss']
})
export class ExternalLoginComponent implements OnInit {

  targetRoute: string;

  constructor(
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private breadcrumbService: BreadcrumbService,
    private store: Store<IState>,
    private router: Router
  ) { }

  ngOnInit() {
    this.authService.clearUserFromLocalStorage();
    this.activatedRoute.queryParams.subscribe(params => {
      const guid = params['guid'];
      if (guid) {
        this.authService.loginExternal(guid).subscribe(res => {
          if (res) {
            const reidrectInfoParams = JSON.parse(res.Parameters);
            this.goToTarget(res.Url, reidrectInfoParams);
          } else {
            window.location.href = environment.logoutRedirectUrl;
          }
        });
      } else {
        window.location.href = environment.logoutRedirectUrl;
      }
    });
    this.breadcrumbService.setBreadcrumb(this.activatedRoute);
  }

  private goToTarget(page: string, params: any) {
    switch (page) {
      case 'claim-detail':
        this.store.dispatch({
          type: AppParamsActions.SET_ID,
          payload: params['id']
        });
        this.router.navigate([page]);
        break;
      case 'app-navigation':
        this.router.navigate(['claim-status']);
        break;
    }
  }

}
